import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/values";
import React from "react";
import { Popper, useTheme } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { ShadowContainer, Typography, Button } from "componentLibrary";
import useWindowSize from "hooks/useWindowSize";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var useStyles = function useStyles() {
  var theme = useTheme();
  return makeStyles(function () {
    return {
      menu: _defineProperty({
        padding: "16px"
      }, theme.breakpoints.up("md"), {
        padding: "24px"
      }),
      actionSection: {
        display: "flex",
        alignItems: "center",
        borderRadius: "0px 0px 16px 16px",
        padding: "16px 24px",
        textAlign: "center",
        boxShadow: "0px 8px 32px 0px #2B028129"
      }
    };
  });
};
var FilterPopper = function FilterPopper(_ref) {
  var _windowSize$innerWidt;
  var title = _ref.title,
    anchorEl = _ref.anchorEl,
    menuRef = _ref.menuRef,
    open = _ref.open,
    onApply = _ref.onApply,
    onClear = _ref.onClear,
    onClose = _ref.onClose,
    children = _ref.children;
  var theme = useTheme();
  var windowSize = useWindowSize();
  var windowWidth = (_windowSize$innerWidt = windowSize.innerWidth) !== null && _windowSize$innerWidt !== void 0 ? _windowSize$innerWidt : 0;
  var classes = useStyles()();
  React.useEffect(function () {
    var handler = function handler(e) {
      var _menuRef$current;
      if (!(menuRef !== null && menuRef !== void 0 && (_menuRef$current = menuRef.current) !== null && _menuRef$current !== void 0 && _menuRef$current.contains(e.target))) {
        onClose();
      }
    };
    document.addEventListener("mousedown", handler);
    return function () {
      document.removeEventListener("mousedown", handler);
    };
  });
  return /*#__PURE__*/_jsx(Popper, {
    anchorEl: anchorEl,
    open: open,
    placement: "bottom-end",
    ref: menuRef,
    modifiers: {
      preventOverflow: {
        enabled: true,
        escapeWithReference: true,
        boundariesElement: "viewport"
      },
      flip: {
        enabled: false
      }
    },
    style: {
      zIndex: 10
    },
    children: /*#__PURE__*/_jsxs(ShadowContainer, {
      style: {
        marginTop: "8px",
        width: windowWidth <= _valuesInstanceProperty(theme.breakpoints).md ? "calc(100vw - 32px)" : 382
      },
      children: [/*#__PURE__*/_jsxs("div", {
        className: classes.menu,
        children: [/*#__PURE__*/_jsx(Typography, {
          style: {
            margin: "8px 0px"
          },
          variant: "h4",
          children: title
        }), /*#__PURE__*/_jsx("div", {
          style: {
            display: "flex",
            flexDirection: "column",
            gap: 8
          },
          children: children
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: classes.actionSection,
        children: [/*#__PURE__*/_jsx(Button, {
          variant: "newTertiary",
          onClick: onClear,
          style: {
            width: "50%"
          },
          children: "Clear All"
        }), /*#__PURE__*/_jsx(Button, {
          style: {
            height: "32px",
            width: "50%"
          },
          variant: "newPrimary",
          onClick: onApply,
          children: "Apply"
        })]
      })]
    })
  });
};
export default FilterPopper;